// extracted by mini-css-extract-plugin
module.exports = {"footer":"Prompt_footer__1zxL1","button":"Prompt_button__1bTaa","confirm":"Prompt_confirm__316vG","text":"Prompt_text__3KXif"};